import React from "react";
var __jsx = React.createElement;
import { t } from "i18next";
export var EncounterReason = function EncounterReason(_ref) {
  var reason = _ref.reason;
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-[12px] text-left text-gray-500 dark:text-gray-500 mb-1"
  }, t("label.reason_for_exam")), /*#__PURE__*/React.createElement("div", {
    className: "text-[16px] text-left text-gray-700 dark:text-gray-300"
  }, (reason === null || reason === void 0 ? void 0 : reason.map(function (reason) {
    return reason;
  }).join(", ")) || "-"));
};